import CurrencyInput from '@app/components/CurrencyInput';
import { getBRCurrencyFormat } from '@app/utils/formmater';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormHelperText,
} from '@material-ui/core';
import React, { forwardRef, Ref, useEffect, useImperativeHandle, useRef, useState } from 'react';
import cls from 'classnames';
import formClasses from '@app/styles/forms.module.css';
import classes from './styles.module.css';

type DialogButton = {
  text: string;
  onClick?: () => void;
};

type DialogOptions = {
  title: string;
  message: string;
  initialValue: number;
  positiveButtonText: string;
  negativeButtonText: string;
  minValue: number;
};

type Props = {};

export type DialogWithChangeInputRefAttrs = {
  // alert: (options: DialogOptions) => void;
  open: (options: DialogOptions) => Promise<number | null>;
};

type ResolverFunction = (value: number | null) => void;

function DialogWithChangeInput(_: Props, ref: Ref<DialogWithChangeInputRefAttrs>) {
  const [dialogOptions, setDialogOptions] = useState<DialogOptions | null>(null);
  const [changeValue, setChangeValue] = useState<number | null>(null);

  const [errorMessage, setErrorMessage] = useState('');

  const choosePromiseResolver = useRef<ResolverFunction | null>(null);

  function handleChoose(options: DialogOptions): Promise<number | null> {
    setDialogOptions(options);
    return new Promise<number | null>((resolve) => {
      choosePromiseResolver.current = resolve;
    });
  }

  useEffect(() => {
    if (dialogOptions) setChangeValue(dialogOptions.initialValue);
  }, [dialogOptions]);

  useEffect(() => {
    setErrorMessage('');
  }, [changeValue]);

  useImperativeHandle(ref, () => {
    return {
      open: handleChoose,
    };
  });

  function handleOnClose() {
    choosePromiseResolver.current && choosePromiseResolver.current(null);
    choosePromiseResolver.current = null;
    setDialogOptions(null);
  }

  function handlePositiveButtonClick() {
    if (changeValue && changeValue <= (dialogOptions?.minValue ?? 0)) {
      setErrorMessage(`O valor do troco deve ser maior que ${getBRCurrencyFormat(dialogOptions?.minValue ?? 0)}`);
      return;
    }
    choosePromiseResolver.current && choosePromiseResolver.current(changeValue);
    choosePromiseResolver.current = null;
    setDialogOptions(null);
  }

  return (
    <Dialog open={Boolean(dialogOptions)} onClose={handleOnClose}>
      <DialogTitle>{dialogOptions?.title ?? ''}</DialogTitle>
      <DialogContent>
        <DialogContentText>{dialogOptions?.message ?? ''}</DialogContentText>
        <CurrencyInput
          defaultValue={dialogOptions?.initialValue ?? ''}
          value={changeValue}
          onNumberValueChange={setChangeValue}
          className={cls(formClasses.textField, classes.input)}
        />
        {errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOnClose}>{dialogOptions?.negativeButtonText ?? ''}</Button>
        <Button onClick={handlePositiveButtonClick}>{dialogOptions?.positiveButtonText ?? ''}</Button>
      </DialogActions>
    </Dialog>
  );
}

export default forwardRef<DialogWithChangeInputRefAttrs, Props>(DialogWithChangeInput);
